module.exports = __webpack_public_path__ + "img/avatar-65.9c581974.png";